import React from 'react';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import './ProfilePage.css';

// TODO: code refactor - rewrite all render... functions into one
function renderUserNameTooltip(props) {
  const tooltip_content = "User name will be used as an account login" ;
  // TODO: update style of tooltips
  return <Tooltip {...props} style={{...props.style}} show={props.show.toString()}>{tooltip_content}</Tooltip>;
}

function renderAccountNumberTooltip(props) {
  const tooltip_content = "Generated randomly account number unique value for each account" ;
  // TODO: update style of tooltips
  return <Tooltip {...props} style={{...props.style}} show={props.show.toString()}>{tooltip_content}</Tooltip>;
}

function renderAcceptsTextsTooltip(props) {
  const tooltip_content = "If checked this phone number is able to receive text messages" ;
  // TODO: update style of tooltips
  return <Tooltip {...props} style={{...props.style}} show={props.show.toString()}>{tooltip_content}</Tooltip>;
}

function renderDoNotCallTooltip(props) {
  const tooltip_content = "If checked this phone number is not eligible to call" ;
  return <Tooltip {...props} show={props.show.toString()}>{tooltip_content}</Tooltip>;
}

function renderDoNotTextTooltip(props) {  
  const tooltip_content = "If checked this phone number is not eligible to text" ;
  return <Tooltip {...props} show={props.show.toString()}>{tooltip_content}</Tooltip>;
}

function renderDoNotEmailTooltip(props) {
  const tooltip_content = "If checked this email is not eligible to email" ;
  return <Tooltip {...props} show={props.show.toString()}>{tooltip_content}</Tooltip>;
}

// TODO: relocate to profile-page.css file
const marginRight4Style = {
  'marginRight':'4px'
}

const displayFlexStyle = {
  'display':'flex',
  'marginTop':'4px'
}

const ProfilePage = () => {
  return (
    <div className="profile-page">
      {/* Page Title */}
      <Row>
        <Col>
        <h2>
          <FontAwesomeIcon className="page-title-icon" icon={faIdCard} />
          <span className="page-title">Profile</span>
        </h2>
      </Col>
      </Row>
      {/* End Page Title */}
      {/* Page Content */}
      <Row>
        <Col>
          <Form className="profile-form">
            <Form.Row>
              <Form.Group as={Col} controlId="formProfileFirstName">
                <Form.Label className="profile-control-label">First Name</Form.Label>
                <Form.Control className="two-col-input" type="text" placeholder="First Name" />
              </Form.Group>

              <Form.Group as={Col} controlId="formProfileLastName">
                <Form.Label className="profile-control-label">Last Name</Form.Label>
                <Form.Control className="two-col-input" type="text" placeholder="Last Name" />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="formProfileUserName">
                <Form.Label className="profile-control-label" style={marginRight4Style}>User Name</Form.Label>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderUserNameTooltip}
                >
                  <FontAwesomeIcon className="profile-info-icon" style={displayFlexStyle} icon={faInfoCircle} />
                </OverlayTrigger>            
                <Form.Control className="two-col-input" type="text" placeholder="User Name" />
              </Form.Group>

              <Form.Group as={Col} controlId="formProfileAccountNumber">
                <Form.Label className="profile-control-label" style={marginRight4Style}>Account Number</Form.Label>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderAccountNumberTooltip}
                >
                  <FontAwesomeIcon className="profile-info-icon" style={displayFlexStyle} icon={faInfoCircle} />
                </OverlayTrigger>
                <Form.Control className="two-col-input" type="text" placeholder="Account Number" disabled />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="formProfilePhone">
                <Form.Label className="profile-control-label">Phone</Form.Label>
                <Form.Control className="two-col-input" type="phone" placeholder="Phone Number" />
              </Form.Group>

              <Form.Group as={Col} className="profile-checkbox-col" controlId="formProfileAcceptsText">
                <Form.Control className="two-col-input profile-checkbox" type="checkbox" placeholder="Accepts Texts" />
                <Form.Label className="profile-control-label">Accepts Texts</Form.Label>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderAcceptsTextsTooltip}
                >
                  <FontAwesomeIcon className="profile-info-icon" icon={faInfoCircle} />
                </OverlayTrigger>
              </Form.Group>
            </Form.Row>

            <Form.Row className="profile-checkbox-row">
              <Form.Group as={Col} className="profile-checkbox-col" controlId="formProfileDoNotCall">
                <Form.Control className="two-col-input profile-checkbox" type="checkbox" placeholder="Do Not Call" />
                <Form.Label className="profile-control-label">Do Not Call</Form.Label>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderDoNotCallTooltip}
                >
                  <FontAwesomeIcon className="profile-info-icon" icon={faInfoCircle} />
                </OverlayTrigger>
              </Form.Group>

              <Form.Group as={Col} className="profile-checkbox-col" controlId="formProfileDoNotText">
                <Form.Control className="two-col-input profile-checkbox" type="checkbox" placeholder="Do Not Text" />
                <Form.Label className="profile-control-label">Do Not Text</Form.Label>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderDoNotTextTooltip}
                >
                  <FontAwesomeIcon className="profile-info-icon" icon={faInfoCircle} />
                </OverlayTrigger>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="formProfileEmail">
                <Form.Label className="profile-control-label">Email</Form.Label>
                <Form.Control className="two-col-input" type="email" placeholder="Email" />
              </Form.Group>

              <Form.Group as={Col} className="profile-checkbox-col" controlId="formProfileDoNotEmail">
                <Form.Control className="two-col-input profile-checkbox" type="checkbox" placeholder="Do Not Email" />
                <Form.Label className="profile-control-label">Do Not Email</Form.Label>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderDoNotEmailTooltip}
                >
                  <FontAwesomeIcon className="profile-info-icon" icon={faInfoCircle} />
                </OverlayTrigger>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="formProfileAddress1">
                <Form.Label className="profile-control-label">Address</Form.Label>
                <Form.Control className="two-col-input" placeholder="Street Address" />
              </Form.Group>

              <Form.Group as={Col} controlId="formProfileAddress2">
                <Form.Label className="profile-control-label">Address 2</Form.Label>
                <Form.Control className="two-col-input" placeholder="Apartment, Studio, or Floor" />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} className="profile-city" controlId="formProfileCity">
                <Form.Label className="profile-control-label">City</Form.Label>
                <Form.Control placeholder="City Name"/>
              </Form.Group>

              <Form.Group as={Col} className="profile-state" controlId="formProfileState">
                <Form.Label className="profile-control-label">State</Form.Label>
                <Form.Control as="select">
                  <option>Choose...</option>
                  <option>...</option>
                </Form.Control>
              </Form.Group>

              <Form.Group as={Col} className="profile-zip" controlId="formProfileZip">
                <Form.Label className="profile-control-label">Zip</Form.Label>
                <Form.Control placeholder="Zip Code"/>
              </Form.Group>
            </Form.Row>
            <hr />
            <Form.Row>
              <Form.Group as={Col} className="profile-buttons">
                <Button variant="primary" type="submit">
                  Save
                </Button>{'   '}
                <Button variant="secondary">
                    Cancel
                </Button>
              </Form.Group>
            </Form.Row>
          </Form>
        </Col>
      </Row>
      {/* End Page Content */}
    </div>
  );
};

export default ProfilePage;